// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEntityOptionsQueryVariables = Types.Exact<{
  entitiesLike: Types.EntityWhereInput;
}>;


export type GetEntityOptionsQuery = { __typename?: 'Query', entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, kind: Types.EntityKind, stage: Types.EntityStage, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null } | null> | null } };

export const Operations = {
  Query: {
    GetEntityOptions: 'GetEntityOptions' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GetEntityOptionsDocument = gql`
    query GetEntityOptions($entitiesLike: EntityWhereInput!) {
  entities(where: $entitiesLike) {
    edges {
      node {
        id
        kind
        stage
        subtype {
          id
          displayName
        }
      }
    }
  }
}
    `;

/**
 * __useGetEntityOptionsQuery__
 *
 * To run a query within a React component, call `useGetEntityOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityOptionsQuery({
 *   variables: {
 *      entitiesLike: // value for 'entitiesLike'
 *   },
 * });
 */
export function useGetEntityOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetEntityOptionsQuery, GetEntityOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntityOptionsQuery, GetEntityOptionsQueryVariables>(GetEntityOptionsDocument, withFetchPolicyContext(options));
      }
export function useGetEntityOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntityOptionsQuery, GetEntityOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntityOptionsQuery, GetEntityOptionsQueryVariables>(GetEntityOptionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetEntityOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEntityOptionsQuery, GetEntityOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEntityOptionsQuery, GetEntityOptionsQueryVariables>(GetEntityOptionsDocument, withFetchPolicyContext(options));
        }
export type GetEntityOptionsQueryHookResult = ReturnType<typeof useGetEntityOptionsQuery>;
export type GetEntityOptionsLazyQueryHookResult = ReturnType<typeof useGetEntityOptionsLazyQuery>;
export type GetEntityOptionsSuspenseQueryHookResult = ReturnType<typeof useGetEntityOptionsSuspenseQuery>;
export type GetEntityOptionsQueryResult = Apollo.QueryResult<GetEntityOptionsQuery, GetEntityOptionsQueryVariables>;